import * as XLSX from 'xlsx';

/**
 * Export data to Excel file
 * @param {Array<Object>} data - Array of objects to export
 * @param {string} fileName - Name of the file (without extension)
 */
export const exportToExcel = (data, fileName) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(data);

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};
